import React from "react";
import { connect } from "react-redux";

import Helmet from 'react-helmet';

import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV2";
import { ThemeProvider } from "styled-components";

import maTheme from "./theme";
import Routes from "./routes/Routes";

function App({ theme }) {
  return (
    <React.Fragment>
      <Helmet
        titleTemplate="%s | Masterplan ERP"
        defaultTitle="Masterplan ERP"
      />
      <StyledEngineProvider injectFirst>
        <MuiThemeProvider theme={maTheme[theme.currentTheme]}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ThemeProvider theme={maTheme[theme.currentTheme]}>
              <Routes />
            </ThemeProvider>
          </LocalizationProvider>
        </MuiThemeProvider>
      </StyledEngineProvider>
    </React.Fragment>
  );
}

export default connect(store => ({ theme: store.themeReducer }))(App);
